import { courseBuilderVisible } from '../courseBuilder/launch';

/**
 * Left sidebar sections — single source of truth.
 * Add new sections/items here; LeftSidebar and the mobile menu pick them up automatically.
 *
 * Item shape:
 *   { id, to, icon (key into SIDEBAR_ICONS), label, sub?, paidOnly?, visible?(), isActive(loc) }
 */
export const SIDEBAR_SECTIONS = [
  {
    id: 'home',
    label: 'Home',
    items: [
      {
        id: 'dashboard',
        to: '/dashboard',
        icon: 'home',
        label: 'Dashboard',
        sub: 'Your command center',
        isActive: (loc) => loc.pathname === '/dashboard',
      },
      {
        id: 'my-learning',
        to: '/my-learning',
        icon: 'chart-bar',
        label: 'My Learning',
        sub: 'Plan, track & resume',
        isActive: (loc) => loc.pathname === '/my-learning',
      },
      {
        id: 'courses',
        to: '/courses',
        icon: 'academic-cap',
        label: 'Courses',
        sub: 'Structured certification paths',
        isActive: (loc) => loc.pathname.startsWith('/courses') && loc.pathname !== '/courses/new',
      },
      {
        id: 'coach',
        to: '/coach',
        icon: 'brain',
        label: 'AI Coach',
        sub: 'Personalized recommendations',
        isActive: (loc) => loc.pathname === '/coach',
      },
    ],
  },
  {
    id: 'ai-tools',
    label: 'AI Features',
    items: [
      {
        id: 'ai-course-builder',
        to: '/courses/new',
        icon: 'sparkles',
        label: 'AI Course Builder',
        sub: 'Your own AI builds a course',
        paidOnly: true,
        visible: courseBuilderVisible,
        isActive: (loc) => loc.pathname === '/courses/new',
      },
      {
        id: 'ai-projects',
        to: '/projects/ai-project-idea-generator',
        icon: 'lightbulb',
        label: 'AI Project Ideas',
        sub: 'Generate custom project ideas',
        paidOnly: true,
        isActive: (loc) => loc.pathname === '/projects/ai-project-idea-generator',
      },
      {
        id: 'ai-roadmap',
        to: '/learning-paths/roadmap',
        icon: 'map',
        label: 'AI Roadmap',
        sub: 'Personalized learning roadmap',
        paidOnly: true,
        isActive: (loc) => loc.pathname === '/learning-paths/roadmap',
      },
      {
        id: 'ai-resume',
        to: '/resume-builder/ai-generate',
        icon: 'document-text',
        label: 'AI Resume Builder',
        sub: 'Generate a tailored resume',
        paidOnly: true,
        isActive: (loc) => loc.pathname === '/resume-builder/ai-generate',
      },
      {
        id: 'ai-cover-letter',
        to: '/cover-letter/ai-generate',
        icon: 'envelope',
        label: 'AI Cover Letter',
        sub: 'Generate cover letters',
        paidOnly: true,
        isActive: (loc) => loc.pathname === '/cover-letter/ai-generate',
      },
      {
        id: 'ai-interview-qa',
        to: '/interview/ai-generate',
        icon: 'chat-bubble',
        label: 'AI Interview Q&A',
        sub: 'Generate Q&A from any topic',
        paidOnly: true,
        isActive: (loc) => loc.pathname === '/interview/ai-generate',
      },
      {
        id: 'ai-mock-interview',
        to: '/virtual-interview',
        icon: 'microphone',
        label: 'AI Mock Interview',
        sub: 'Live AI-powered practice',
        paidOnly: true,
        isActive: (loc) => loc.pathname === '/virtual-interview',
      },
      {
        id: 'ai-cert-exam',
        to: '/cert-exam',
        icon: 'badge-check',
        label: 'AI Cert Exam Prep',
        sub: 'AWS, Azure, GCP & K8s',
        paidOnly: true,
        isActive: (loc) => loc.pathname === '/cert-exam',
      },
    ],
  },
  {
    id: 'community',
    label: 'Community',
    items: [
      {
        id: 'social',
        to: '/social/feed',
        icon: 'user-group',
        label: 'Social Pro Share',
        sub: 'Share & learn together',
        paidOnly: true,
        isActive: (loc) => loc.pathname.startsWith('/social'),
      },
      {
        id: 'leaderboard',
        to: '/leaderboard',
        icon: 'trophy',
        label: 'Leaderboard',
        sub: 'Top scorers',
        isActive: (loc) => loc.pathname.startsWith('/leaderboard'),
      },
      {
        id: 'teams',
        to: '/teams',
        icon: 'building',
        label: 'Team',
        sub: 'Company / team plan',
        isActive: (loc) => loc.pathname.startsWith('/teams'),
      },
    ],
  },
];
